// extracted by mini-css-extract-plugin
module.exports = {"container":"Question_container__kI0Z3","link":"Question_link__r3tZ9","tags":"Question_tags__SZNof","question":"Question_question__qLDIu"};